import type { FC } from "react";

import type { FlowCustomComponentProps } from "@/shared/constants/flowTypes";

import { PropertyLoanForm, HELOC_CONFIG } from "./PropertyLoanForm";

interface PropertyHELOCProps extends FlowCustomComponentProps {
  propertyId: number;
}

export const PropertyHELOC: FC<PropertyHELOCProps> = (props) => (
  <PropertyLoanForm {...props} config={HELOC_CONFIG} />
);
